/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_GenderInputs */

const en_reference_dataset_gender = /** @type {(inputs: Reference_Dataset_GenderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genders`)
};

/**
* | output |
* | --- |
* | "Genders" |
*
* @param {Reference_Dataset_GenderInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_gender = /** @type {((inputs?: Reference_Dataset_GenderInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_GenderInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_gender(inputs)
});